import React from "react";
import PropTypes from "prop-types";
import styles from "components/upload-documents/upload-inline-tabs.scss";
import { InlineTabs } from "components/common/inline-tabs";

export const UploadInlineTabs = ({ accountSlug, currentPage }) => (
  <div className={ `${styles.container} manual3` }>
    <InlineTabs tabValues={ tabValues(currentPage, accountSlug) } />
  </div>
);

UploadInlineTabs.propTypes = {
  accountSlug: PropTypes.string.isRequired,
  currentPage: PropTypes.oneOf(["upload", "awaiting-digital", "awaiting-mailin"]).isRequired
};

const tabValues = (currentPage, accountSlug) => (
  [
    {
      name: "Upload",
      path: `/accounts/${accountSlug}/upload`,
      isSelected: currentPage === "upload"
    },
    {
      name: "Awaiting Digital Submissions",
      path: `/accounts/${accountSlug}/awaiting-digital`,
      isSelected: currentPage === "awaiting-digital"
    },
    {
      name: "Awaiting Mail in",
      path: `/accounts/${accountSlug}/awaiting-mailin`,
      isSelected: currentPage === "awaiting-mailin"
    }
  ]
);



// WEBPACK FOOTER //
// ./src/js/components/upload-documents/upload-inline-tabs.jsx